import React from 'react';

interface BookPageProps {
  eyebrow: string;
  title: string;
  intro?: string;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  maxWidthClassName?: string;
  headerAside?: React.ReactNode;
}

const BookPage: React.FC<BookPageProps> = ({
  eyebrow,
  title,
  intro,
  children,
  className = '',
  bodyClassName = '',
  maxWidthClassName = 'max-w-5xl',
  headerAside,
}) => {
  return (
    <article className={`px-4 pb-16 pt-6 md:pb-20 md:pt-8 ${className}`}>
      <div className={`mx-auto ${maxWidthClassName}`}>
        <div className="relative overflow-hidden rounded-[1rem] border border-[color:var(--wf-border-strong)] bg-[linear-gradient(180deg,rgba(252,248,241,0.985),rgba(244,236,224,0.965))] shadow-[0_32px_80px_rgba(20,12,8,0.22)]">
          <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(166,132,85,0.05),transparent_14%,transparent_86%,rgba(95,70,92,0.05))]" />
          <div className="absolute inset-[10px] rounded-[0.65rem] border border-[rgba(137,108,74,0.14)] pointer-events-none" />

          <div className="relative px-6 py-8 sm:px-10 md:px-14 md:py-10">
            <header className="border-b border-[color:var(--wf-border)] pb-8">
              <div className="flex flex-wrap items-start justify-between gap-6">
                <div className="min-w-0 flex-1">
                  <p className="text-xs uppercase tracking-[0.3em] text-[color:var(--wf-brass)]">{eyebrow}</p>
                  <h1 className="mt-4 font-serif text-4xl leading-tight text-[color:var(--wf-ink)] sm:text-5xl">
                    {title}
                  </h1>
                  <div className="mt-4 h-px w-44 bg-gradient-to-r from-[color:var(--wf-brass)] via-[color:var(--wf-plum-soft)] to-transparent" />
                  {intro && (
                    <p className="mt-5 max-w-2xl text-sm leading-7 text-[color:var(--wf-ink-soft)] sm:text-base">
                      {intro}
                    </p>
                  )}
                </div>
                {headerAside && <div className="shrink-0 text-sm leading-7 text-[color:var(--wf-ink-soft)]">{headerAside}</div>}
              </div>
            </header>

            <div className={`pt-8 ${bodyClassName}`}>{children}</div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default BookPage;
